import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaInformacionDireccionesListaItemComponent {
  empresaId = undefined
  editando = false
  data = {}
  onChange = undefined
  onDelete = undefined

  actualizar (data) {
    Object.assign(this.data, data)
  }

  actualizarMatriz () {
    this.onChange()
  }

  eliminar () {
    this.onDelete()
  }
}

module.component('empresaInformacionDireccionesListaItem', {
  controller: EmpresaInformacionDireccionesListaItemComponent,
  template,
  bindings: {
    empresaId: '<',
    data: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/direcciones/lista/item/component.js